import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';
import { MenuItemModel } from '../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Your Questions',
    ImagePath: '/assets/images/landing/online-workbook.png',
    DestinationPage: 'Exam-Practice-Questions',
  },
  {
    Text: 'Quizzes',
    ImagePath: '/assets/images/landing/quick-quizzes.png',
    DestinationPage: 'Quick-Quiz',
  },
  {
    Text: 'Videos',
    ImagePath: '/assets/images/landing/video-solutions.png',
    DestinationPage: 'Worked-Answer-Videos',
  },
  {
    Text: 'Extra Bits',
    ImagePath: '/assets/images/landing/pdfs.png',
    DestinationPage: 'Extras',
  },
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.ExamPracticeQuestions,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Exam Practice Questions',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/PAFQ43/PAFQ43_DigitalWorkbook_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Exam Practice Questions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>' +
      '\n' +
      '<p>Questions marked: <strong>[[variable1]]</strong></p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'All the questions from your book',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Maths Skills Quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/PAFQ43/PAFQ43_MathsSkills_v4',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    ButtonURL: 'quick-quiz',
    HasData: true,
    HeadingText: 'Maths Skills Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      "<p>Test yourself on the Maths Skills you\'ll need to help with each Paper.</p>\n" +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Last quiz score: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Extra practice on the tricky Maths bits',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "We've put together lots of helpful information on how to get the most out of your Revision Guide. And if you've hit any snags, you'll find the answers you need here too.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: 'Fun image of toucan peeking out from behind the useful PDFs',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/PAFQ43/PAFQ43_MathsSkills_Mistakes_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>The quick quiz questions you got wrong are here &mdash; have another go and conquer them once and for all!</p>\n' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers\n',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.VideoSolutions,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    MixedOnlineTests: [],

    ButtonURL: '',
    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Worked answer videos with lots of advice to help you scoop up every last mark.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Help with answering the questions',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book`have a go at the questions first and use these videos if you need a bit of extra help.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book`have a go at the questions first and use these videos if you need a bit of extra help.\n",
        LeftSections: [
          {
            Header: 'Topic 1 — Energy\n',
            Subcategories: [
              {
                Name: 'Conservation of Energy and Energy Transfers',
                ShortName: 'Conservation-of-Energy-and-Energy-Transfers',
                Link: 'https://www.youtube.com/embed/eBKrEQLCBfs?rel=0&modestbranding=1',
              },
              {
                Name: 'Reducing Unwanted Energy Transfers',
                ShortName: 'Reducing-Unwanted-Energy-Transfers',
                Link: 'https://www.youtube.com/embed/mMepPtkOisQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Hydro-electricity, Waves and Tides',
                ShortName: 'Hydro-electricity-Waves-and-Tides',
                Link: 'https://www.youtube.com/embed/AcqF61bpNok?rel=0&modestbranding=1',
              },
              {
                Name: 'Trends in Energy Resource Use',
                ShortName: 'Trends-in-Energy-Resource-Use',
                Link: 'https://www.youtube.com/embed/keBp0ZOsCv0?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2 — Electricity\n',
            Subcategories: [
              {
                Name: 'Investigating Resistance',
                ShortName: 'Investigating-Resistance',
                Link: 'https://www.youtube.com/embed/Dw-v6eydZjQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Circuit Devices',
                ShortName: 'Circuit-Devices',
                Link: 'https://www.youtube.com/embed/ifnErzOnJXE?rel=0&modestbranding=1',
              },
              {
                Name: 'The National Grid',
                ShortName: 'The-National-Grid',
                Link: 'https://www.youtube.com/embed/9gxgHiB8VYM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 3 — Particle Model of Matter\n',
            Subcategories: [
              {
                Name: 'The Particle Model and Density',
                ShortName: 'the-particle-model-and-density',
                Link: 'https://www.youtube.com/embed/JLdGevkU3Tk?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 4 — Atomic Structure\n',
            Subcategories: [
              {
                Name: 'Developing the Model of the Atom',
                ShortName: 'developing-the-model-of-the-atom',
                Link: 'https://www.youtube.com/embed/J7-u4XFz230?rel=0&modestbranding=1',
              },
              {
                Name: 'Nuclear Equations',
                ShortName: 'nuclear-equations',
                Link: 'https://www.youtube.com/embed/pRya0hSB_io?rel=0&modestbranding=1',
              },
              {
                Name: 'Half-life',
                ShortName: 'half-life',
                Link: 'https://www.youtube.com/embed/fs9ylPSOHIw?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Topic 5a — Forces, Moments & Pressure\n',
            Subcategories: [
              {
                Name: 'Weight, Mass and Gravity',
                ShortName: 'weight-mass-and-gravity',
                Link: 'https://www.youtube.com/embed/zT1G9EUinfo?rel=0&modestbranding=1',
              },
              {
                Name: 'Investigating Springs',
                ShortName: 'investigating-springs',
                Link: 'https://www.youtube.com/embed/yUpDLToESac?rel=0&modestbranding=1',
              },
              {
                Name: 'Moments',
                ShortName: 'moments',
                Link: 'https://www.youtube.com/embed/9McA0P3wC8k?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 5b — Forces and Motion\n',
            Subcategories: [
              {
                Name: 'Distance, Displacement, Speed and Velocity',
                ShortName: 'distance-displacement-speed-and-velocity',
                Link: 'https://www.youtube.com/embed/FAjB9av7pQk?rel=0&modestbranding=1',
              },
              {
                Name: 'Velocity-Time Graphs and Terminal Velocity',
                ShortName: 'velocity-time-graphs-and-terminal-velocity',
                Link: 'https://www.youtube.com/embed/ItX-Z2EWTQw?rel=0&modestbranding=1',
              },
              {
                Name: 'Reaction Times',
                ShortName: 'reaction-times',
                Link: 'https://www.youtube.com/embed/qJ7VysNK98s?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6a — Wave Basics & EM Waves\n',
            Subcategories: [
              {
                Name: 'Refraction',
                ShortName: 'refraction',
                Link: 'https://www.youtube.com/embed/b2PdSCKabqs?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6b — Light, Radiation & Other Waves\n',
            Subcategories: [
              {
                Name: 'Lenses and Images',
                ShortName: 'lenses-and-images',
                Link: 'https://www.youtube.com/embed/LgYxRr2L7JY?rel=0&modestbranding=1',
              },
              {
                Name: 'Investigating IR Radiation',
                ShortName: 'investigating-ir-radiation',
                Link: 'https://www.youtube.com/embed/MrwcE6VxfV4?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 8 — Space Physics\n',
            Subcategories: [
              {
                Name: 'The Solar System and Stars',
                ShortName: 'the-solar-system-and-stars',
                Link: 'https://www.youtube.com/embed/6B8cNaPdrzo?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Mixed Questions\n',
            Subcategories: [
              {
                Name: 'Mixed Questions (1)',
                ShortName: 'mixed-questions-1',
                Link: 'https://www.youtube.com/embed/OgPEPXmAtUY?rel=0&modestbranding=1',
              },
              {
                Name: 'Mixed Questions (2)',
                ShortName: 'mixed-questions-2',
                Link: 'https://www.youtube.com/embed/IW13kJh8TPQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Mixed Questions (3)',
                ShortName: 'mixed-questions-3',
                Link: 'https://www.youtube.com/embed/-z6vC5NBXmU?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Formula sheets and exam advice at your fingertips!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: 'We?ve put together lots of helpful information on how to get the most out of your Revision Guide. And if you?ve hit any snags, you?ll find the answers you need here too.',
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<p>Here are your formula sheets, plus tips on what to expect in the exams.</p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/PAFQ43/PDFs/cgp-gcse-physics-formulas-foundation.pdf" style="color: rgb(20, 148, 212);" target="_blank">Formula Sheet</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/PAFQ43/PDFs/cgp-gcse-physics-examhelp-foundation.pdf" style="color: rgb(20, 148, 212);" target="_blank">What to Expect in the Exams</a></p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Library',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Watch our useful video to get started or take a look at the FAQs if you need some help.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine:
        "We've put together lots of helpful information on how to get the most out of your Exam Practice Workbook. And if you've hit any snags, you'll find the answers you need here too. ",
      Text:
        ' <h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5><strong>What is CGP RevisionHub?</strong><strong>&nbsp;</strong></h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Science Workbooks. Use the quizzes, tests, videos and more to make sure you know your stuff for the exams. &nbsp;&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I access CGP RevisionHub?</strong><strong>&nbsp;</strong></h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.&nbsp;&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I use CGP RevisionHub with my book?</strong>&nbsp;</h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Just give them a scan and you'll automatically be taken to the relevant quiz, video or other revision thingy-ma-jig!&nbsp;<strong>&nbsp;</strong><br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>My CGP RevisionHub isn’t working — what do I do?</strong><strong>&nbsp;</strong></h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact"><u>Customer Services team</u></a>.&nbsp;</p>\n' +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge...&nbsp;&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Do I need an internet connection to use CGP RevisionHub?</strong><strong>&nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Yes, you do. But don't cancel your revision retreat to a remote mountain cave just yet — there are also useful bits that you can download as PDFs to access offline. Phew.&nbsp; &nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>If I log in on a different device, will all my progress be saved?</strong><strong>&nbsp;</strong></h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you.&nbsp; &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>What’s the difference between the Quick Quizzes and Your Mistakes Quiz?</strong><strong>&nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Quick Quizzes are...well, quick! They're a speedy way to test yourself on all the maths skills you’ll need for the course. There's a quiz covering maths skills for Paper 1 and another for Paper 2.&nbsp;</p>\n" +
        '\n' +
        "<p>Your Mistakes Quiz tests you on any questions you got wrong in your Quick Quizzes. It's really helpful for targeting those bits you find trickier. &nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I use the Online Workbook?</strong><strong>&nbsp;</strong></h5>\n' +
        '\n' +
        '<p>All the questions from your book are available to answer again online and you can filter them by paper or by type, e.g. Practical Skills. There’s also a QR code on each page of your book that will take you directly to the questions for that page. You’ll mark some of the questions yourself by looking at the answers, and the rest are marked automatically in CGP RevisionHub — wow!<strong> &nbsp;</strong><br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Can I clear my progress so far in CGP RevisionHub and start again?</strong><strong>&nbsp;</strong></h5>\n' +
        '\n' +
        '<p>You can reset your answers in the Online Workbook any time you like! There are no takie-backsies in the quizzes though, so you can’t wipe your results and start again from scratch. But practice makes perfect, and you can take the quizzes as many times as you want to improve your scores. Keep going, we believe in you!&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Can I share my quiz scores and test results with other people?</strong><strong>&nbsp;</strong></h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?&nbsp;&nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>What happens when I’ve answered all the questions?</strong><strong>&nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Ah, one of life's greatest questions — what next? We'd recommend that you keep practising right up until your exams. You’ve got this.&nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Will I always have access to CGP RevisionHub?</strong><strong>&nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they’ll be three whole years of bliss, we promise. <br>\n" +
        '&nbsp;</p>',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },

  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "There's plenty more revision where this came from. Take a look at some of our other books!",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: 'GCSE Combined Science',
      BookType: 'Revision Guide',
      AdditionalText: "(you'll find some excellent jokes along the way)",
    },
  },
];

